module.exports = __webpack_public_path__ + "static/img/logo_2_black32.c928ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_2_black32.png
// module id = +/nJ
// module chunks = 26